module.exports = __webpack_public_path__ + "static/thierry_baillet-65278be84209b775ecc6b50f117952b1.png";